<div
  class="container-filter__padding"
  matMenuContent
  (click)="$event.stopPropagation()"
>
  <mat-radio-group
    [ngModel]="filtroOrigem"
    (ngModelChange)="onFiltroChange($event)"
    disabledInteractive
  >
    <div class="item-filter">
      <div class="lista">
        @for(origem of origemOptions; track origem){
        <div class="item">
          <mat-radio-button
            class="filter-radio-margin"
            disableRipple
            color="primary"
            [value]="origem.value"
            labelPosition="before"
            (click)="onRadioClick($event, origem.value)"
          >
            <div style="position: absolute; width: 90%; height: 17%; cursor: pointer;"></div>
            <span class="filter-text" style="cursor: pointer">{{
              origem.viewValue
            }}</span>
          </mat-radio-button>
        </div>
        }
      </div>
    </div>
  </mat-radio-group>
</div>
